export interface ApiAuthor {
    id?: string
    fullName?: string
    slug?: string
    numStories?: number;
}

export const getAuthorId = (author: ApiAuthor) => author.id ?? ''

export const getAuthorFullName = (author: ApiAuthor) => author.fullName ?? ''

export const getAuthorSlug = (author: ApiAuthor) => author.slug ?? "";

export const getNumStories = (author: ApiAuthor) => author.numStories ?? 0